import * as Yup from 'yup'

const bnkWarehouseLocationCreateSchema = Yup.object().shape({
  name      : Yup.string().required('Required'),
  type_name : Yup.string().required('Required'),
  active    : Yup.boolean().required('Required')
})

export default bnkWarehouseLocationCreateSchema
